
const INITIAL_STATE = {
    error: false,
    loading: false,
    data: []
}

const DeleteCupom = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'CUPOM_DELETE_REQUEST':
            return { loading: true, error: false, data: [] }
        case 'CUPOM_DELETE_ERROR':
            return { loading: false, error: true, data: [] };
        case 'CUPOM_DELETE_SUCCESS':
            return { loading: false, error: false, data: action.payload };
        case 'CUPOM_DELETE_RESET':
            return { loading: false, error: false, data: [] }; 
        default:
            return state;
    }
}

export default DeleteCupom